<app-tab>
  <dx-data-grid
    id="trackersGridContainer"
    [dataSource]="ds"
    [libGridDefault]="{ stateStorageKey: 'app-trailer-trackers-grid' }"
    [libGridTitle]="{ text: 'Boitiers GPS' }"
    [masterDetail]="{ enabled: true, template: 'params' }"
    (onInitNewRow)="onInitNewRow($event)"
    (onEditingStart)="onEditingStart($event)"
  >
    <dxi-column
      caption="ID"
      dataField="id"
      sortOrder="desc"
      width="5%"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataType="number"
    >
    </dxi-column>

    <dxi-column caption="IMEI" dataField="imei" dataType="number">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule
        type="pattern"
        [pattern]="imeiPattern"
      ></dxi-validation-rule>
      <dxi-validation-rule
        type="async"
        message="IMEI existe déjà"
        [validationCallback]="imeiValidation"
      ></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="SIM"
      dataField="sim_number"
      [editorOptions]="{
        mask: '+212 0 00 00 00 00',
        maskRules: phonePattern,
        useMaskedValue: true
      }"
    >
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule
        type="pattern"
        [pattern]="phonePattern"
      ></dxi-validation-rule>
      <dxi-validation-rule type="stringLength" [max]="45"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Marque"
      dataField="brand"
      [showInColumnChooser]="false"
      editCellTemplate="brandEditor"
    >
      <div *dxTemplate="let cellInfo of 'brandEditor'">
        <dx-lookup
          [dataSource]="brandSrc"
          (onValueChanged)="onBrandChanged($event, cellInfo)"
          [value]="selectedBrand"
          [inputAttr]="{ 'aria-label': 'Lookup' }"
        >
          <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
        </dx-lookup>
      </div>
    </dxi-column>

    <dxi-column
      caption="Modèle"
      dataField="model"
      editCellTemplate="ModelEditor"
      ><div *dxTemplate="let cellInfo of 'ModelEditor'">
        <dx-lookup
          [dataSource]="modelsSrc"
          (onValueChanged)="updateCellValue($event, cellInfo, 'selectedModel')"
          [value]="selectedModel"
          [inputAttr]="{ 'aria-label': 'Lookup' }"
        >
          <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
        </dx-lookup>
      </div>
    </dxi-column>

    <dxi-column caption="Odomètre" dataField="odometer" dataType="number">
    </dxi-column>

    <dxi-column
      caption="Heures Moteur"
      dataField="engine_hours"
      dataType="number"
    >
    </dxi-column>

    <dxi-column
      caption="Tracteur"
      [allowEditing]="false"
      [customizeText]="displayCheckAvailable"
      [formItem]="{ visible: false }"
      dataField="tractor.name"
    >
    </dxi-column>

    <dxi-column
      caption="Domaine"
      [allowEditing]="false"
      [customizeText]="displayCheckAvailable"
      [formItem]="{ visible: false }"
      dataField="domain_name"
    >
    </dxi-column>

    <dxi-column
      caption="BU"
      [allowEditing]="false"
      [customizeText]="displayCheckAvailable"
      [formItem]="{ visible: false }"
      dataField="business_unit_name"
    >
    </dxi-column>

    <dxi-column
      caption="Date création"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataField="created_at"
      format="shortDateShortTime"
      dataType="date"
    >
    </dxi-column>

    <dxi-column
      caption="Date modification"
      [allowEditing]="false"
      [formItem]="{ visible: false }"
      dataField="updated_at"
      format="shortDateShortTime"
      dataType="date"
    >
    </dxi-column>

    <dxi-column
      caption="Paramètre Gasoil 1"
      [visible]="false"
      [showInColumnChooser]="false"
      editCellTemplate="fuelEditor1"
      dataField="settings.fuel1"
    >
      <div *dxTemplate="let cellInfo of 'fuelEditor1'">
        <lib-fuel-params-editor
          (paramsChange)="cellInfo.setValue($event)"
          [params]="cellInfo.value"
        ></lib-fuel-params-editor>
      </div>
    </dxi-column>

    <dxi-column
      caption="Paramètre Gasoil 2"
      [visible]="false"
      [showInColumnChooser]="false"
      editCellTemplate="fuelEditor2"
      dataField="settings.fuel2"
    >
      <div *dxTemplate="let cellInfo of 'fuelEditor2'">
        <lib-fuel-params-editor
          (paramsChange)="cellInfo.setValue($event)"
          [params]="cellInfo.value"
        ></lib-fuel-params-editor>
      </div>
    </dxi-column>

    <dxi-column type="buttons" [allowHiding]="false" [width]="110">
      <dxi-button
        hint="Liste des transferts"
        icon="sorted"
        [visible]="canAssign"
        [onClick]="navigateToTrackerAssignment"
      ></dxi-button>
      <dxi-button name="edit"></dxi-button>
      <dxi-button name="delete"></dxi-button>
    </dxi-column>

    <dxi-column
      [visible]="false"
      [showInColumnChooser]="false"
      caption="c'est une pompe?"
      dataType="boolean"
      editCellTemplate="pumpEditor"
      dataField="is_pump"
    >
      <div *dxTemplate="let cellInfo of 'pumpEditor'">
        <div style="height: 35px" class="flex felx items-center h-full">
          <dx-switch
            [value]="cellInfo.value"
            (onValueChanged)="updateCellValue($event, cellInfo, 'isPump')"
          ></dx-switch>
        </div>
      </div>
    </dxi-column>

    <dxi-column
      dataField="settings.feul_data_source"
      caption="source de données sur le carburant"
      [visible]="false"
      [allowSearch]="false"
      [showInColumnChooser]="false"
      [allowSearch]="false"
      editCellTemplate="feulDataSourceEditor"
    >
      <div *dxTemplate="let cellInfo of 'feulDataSourceEditor'">
        <dx-lookup
          [dataSource]="feulDataSources"
          displayExpr="text"
          valueExpr="value"
          [value]="feulDataSource"
          [inputAttr]="{ 'aria-label': 'Lookup' }"
          (onValueChanged)="updateCellValue($event, cellInfo, 'feulDataSource')"
        >
          <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
        </dx-lookup>
      </div>
    </dxi-column>

    <dxi-column
      [allowSearch]="false"
      caption="carburant consommé"
      dataField="settings.fuel_consumption.sensor"
      editCellTemplate="fuelConsumptionEditor"
    >
      <div *dxTemplate="let cellInfo of 'fuelConsumptionEditor'">
        <dx-select-box
          [dataSource]="canBusSensors"
          displayExpr="text"
          valueExpr="value"
          searchEnabled="true"
          [value]="fuelConsumption"
          (onValueChanged)="
            updateCellValue($event, cellInfo, 'fuelConsumption')
          "
        >
        </dx-select-box>
      </div>
    </dxi-column>

    <dxi-column
      caption="formule"
      [visible]="false"
      [allowSearch]="false"
      [showInColumnChooser]="false"
      [allowSearch]="false"
      dataField="settings.fuel_consumption.formula"
    >
    </dxi-column>

    <dxi-column
      [allowSearch]="false"
      caption="Taux de consommation de carburant"
      dataField="settings.fuel_hr_consumption_rate.sensor"
      [allowSearch]="false"
      editCellTemplate="fuelHrConsumptionRateEditor"
    >
      <div *dxTemplate="let cellInfo of 'fuelHrConsumptionRateEditor'">
        <dx-select-box
          [dataSource]="canBusSensors"
          displayExpr="text"
          valueExpr="value"
          searchEnabled="true"
          [value]="fuelHrConsumptionRate"
          (onValueChanged)="
            updateCellValue($event, cellInfo, 'fuelHrConsumptionRate')
          "
        >
        </dx-select-box>
      </div>
    </dxi-column>

    <dxi-column
      caption="formule"
      [visible]="false"
      [allowSearch]="false"
      [showInColumnChooser]="false"
      [allowSearch]="false"
      dataField="settings.fuel_hr_consumption_rate.formula"
    >
    </dxi-column>

    <dxo-editing
      mode="popup"
      [allowDeleting]="canDelete"
      [allowAdding]="canAdd"
      [allowUpdating]="canEdit"
    >
      <dxo-popup width="50%"></dxo-popup>

      <dxo-form labelLocation="top">
        <dxi-item dataField="imei"></dxi-item>
        <dxi-item dataField="sim_number"></dxi-item>
        <dxi-item dataField="brand"
          ><dxi-validation-rule type="required"></dxi-validation-rule
        ></dxi-item>
        <dxi-item dataField="model"
          ><dxi-validation-rule type="required"></dxi-validation-rule
        ></dxi-item>
        <dxi-item dataField="odometer"></dxi-item>
        <dxi-item dataField="engine_hours"></dxi-item>
        <dxi-item
          itemType="group"
          colSpan="2"
          colCount="2"
          caption="Paramètres"
        >
          <dxi-item dataField="settings.fuel1"></dxi-item>
          <dxi-item dataField="settings.fuel2"></dxi-item>
        </dxi-item>
        <dxi-item caption="pompe?" dataField="is_pump"></dxi-item>
        <dxi-item dataField="settings.feul_data_source"></dxi-item>

        <dxi-item
          [visible]="feulDataSource == 'canbus'"
          itemType="group"
          colSpan="2"
          colCount="2"
          caption="Can paramètres"
        >
          <dxi-item
            dataField="settings.fuel_hr_consumption_rate.sensor"
          ></dxi-item>
          <dxi-item
            dataField="settings.fuel_hr_consumption_rate.formula"
          ></dxi-item>
          <dxi-item dataField="settings.fuel_consumption.sensor"></dxi-item>
          <dxi-item dataField="settings.fuel_consumption.formula"></dxi-item>
        </dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export
      [enabled]="true"
      fileName="liste-traceurs"
      [allowExportSelectedData]="true"
    ></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-paging [pageSize]="25"></dxo-paging>

    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true"
    >
    </dxo-pager>

    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>

    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <div *dxTemplate="let cell of 'params'">
      <div style="width: 100%; display: inline-block; white-space: pre-wrap">
        <ng-container *ngFor="let p of cell.data.params | keyvalue">
          <div class="param-badge" [ngClass]="{ green: p.value == 1 }">
            <b>{{ p.key }}:</b> {{ p.value }}
          </div>
        </ng-container>
      </div>
    </div>
  </dx-data-grid>
</app-tab>
